import { BaseToolbarNavPageLayout } from './baseLayoutViews';

/**
 * A Backbone wrapper for a React page. This acts as a compatibility layer between
 * our Backbone app + navigation system and newer React pages.
 */
export const ReactPageWrapper = BaseToolbarNavPageLayout.extend({
    use_transitions: true,
    renderFunction: () => {},

    initialize: function (options = {}) {
        $.extend(this, options);
        this.toolbarnav_class = null; // the React page should implement its own toolbarnav
    },

    render: function () {
        window.mountReactJSX(this.el, () => this.renderFunction());
    },

    onClose: function () {
        window.unmountReact(this.el);
    }
});
